export const environment = {
  instance: "qa",
  production: false, 
  showLogs: true,
  region: 'ap-southeast-1', 
  bucketName: 'bbb-boc-files',
  cognitoUserPoolId: 'ap-southeast-1_aTRTZfvgX', 
  cognitoAppClientId: '5cb2l5rul6rld93l5b87dooe2f', 
  cognitoIdentityEndpoint: 'cognito-idp.ap-southeast-1.amazonaws.com/ap-southeast-1_aTRTZfvgX', 
  cognitoIdentityPoolId: 'ap-southeast-1:be7649d5-cbc7-427b-8e2b-4ff2ea036902',
  apiEndpoint: 'https://umjqzjcm2g.execute-api.ap-southeast-1.amazonaws.com/qa/',  
  auth: {
    identityPoolId: 'ap-southeast-1:be7649d5-cbc7-427b-8e2b-4ff2ea036902',
    region: 'ap-southeast-1',
    userPoolId: 'ap-southeast-1_aTRTZfvgX',
    userPoolWebClientId: '5cb2l5rul6rld93l5b87dooe2f',
    mandatorySignIn: false,
    authenticationFlowType: 'USER_SRP_AUTH'
  },
  api: {
    endpoints: [
      {
        name: "BOCAPis",
        endpoint: "https://umjqzjcm2g.execute-api.ap-southeast-1.amazonaws.com"
      }
    ]
  }
};